import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromPersonnelDetailState from './personnel-detail.reducer';
import { PersonnelDetailEffects } from './personnel-detail.effects';

@NgModule({
	imports: [
		StoreModule.forFeature(
			fromPersonnelDetailState.personnelDetailFeatureKey,
			fromPersonnelDetailState.reducer
		),
		EffectsModule.forFeature([PersonnelDetailEffects]),
	],
})
export class PersonnelDetailStateModule {}
